export interface UiSettingsModel {
  hideLoginButton?: boolean;
  enable3D?: boolean;
}
